import React, { useMemo } from'react';

type TextProps = {
    dataName: string,
    title: string,
    value: string,
    visible?: boolean
    readonly?: boolean,
    timeValue?: boolean,
    hintText?: string,
    required?: boolean,
    defaultCurrentDate?: boolean,
    restrictPreviousDate?: boolean
    onchange?: (e: any) => void,
    className?: string,
    inputClassName?: string,
};

const DateField = ({
    dataName,
    title,
    hintText,
    visible = true,
    readonly,
    timeValue,
    required,
    value,
    defaultCurrentDate,
    restrictPreviousDate,
    onchange,
    className,
    inputClassName,
}: TextProps) => {
    const currentDate = useMemo(() => {
        const today = new Date();
        return today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2);
    }, []);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let enteredValue = event.target.value;

        if (restrictPreviousDate && new Date(enteredValue) < new Date(currentDate)) {
            enteredValue = currentDate;
        }

        if (onchange) {
            onchange(enteredValue);
        }
    };

    const requiredValue = readonly ? false : required;
    const titleLabel = title ? (
        <div>
            <b>
                <label htmlFor={dataName}>
                    {title}{' '}
                    {requiredValue ? <label className='required'>*</label> : ''}
                </label>
            </b>
            <br />
        </div>
    ) : null;

    const wrapperClass = `form-group ComponentDivs${className ? ' ' + className : ''}`;
    const inputClass = `Value form-control input-lg${inputClassName ? ' ' + inputClassName : ''}`;

    // defaultCurrentDate behavior: if no value yet and we want current date
    const effectiveValue = !readonly && defaultCurrentDate && !value ? currentDate : value ?? '';

    return visible ? (
        <div className={wrapperClass}>
            {titleLabel}
            <p className='HintText'>{readonly ? '' : hintText}</p>
            <input
                readOnly={readonly}
                className={inputClass}
                type={timeValue ? 'datetime-local' : 'date'}
                name={dataName}
                value={effectiveValue}
                onChange={handleChange}
                required={requiredValue}
            />
        </div>
    ) : (
        <></>
    );
};

export default DateField